export function capitalizeText(text: string): string {
    text = text.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function stringifyText(text: string | object | undefined): string {
    return typeof text === 'string' ? text : JSON.stringify(text);
}
